import React from "react";
import HomeSideNavBar from "../HomeSideNavBar";
import Header from "../Header";
import ApiDataProvider from "../ApiDataContext";
import ListAuditLogs from "./ListAuditLogs";
import PageHeader from "../../components/layout/PageHeader";

function AuditLog() {
  const role = localStorage.getItem("role");
  const isSuperAdmin = role === "SUPER_ADMIN";

  // Only CLIENT_ADMIN, CLIENT_MANAGER, and SUPER_ADMIN may access this page.
  // CLIENT_EMPLOYEE is redirected to home.
  if (role === "CLIENT_EMPLOYEE") {
    window.location.href = "/home";
    return null;
  }

  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <PageHeader
              title="Audit Log"
              subtitle={isSuperAdmin
                ? "Platform-wide audit trail across all tenants."
                : "Audit trail for your organisation."
              }
              breadcrumbs={[{label: "Insights"}, {label: "Audit Log"}]}
            />
            <div className="flex-1 min-h-0 px-2 sm:px-4 lg:px-6 py-4">
              <ListAuditLogs isSuperAdmin={isSuperAdmin} />
            </div>
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default AuditLog;
